import { render, staticRenderFns } from "./WikiProposalsList.vue?vue&type=template&id=1ac11f4d&"
import script from "./WikiProposalsList.vue?vue&type=script&lang=js&"
export * from "./WikiProposalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports